export enum SpecialUseVehicleType {
    UNSPECIFIED = 'unspecified',
    AMBULANCE = 'ambulance',
    TAXI = 'taxi',
    SPECIAL_USE_VEHICLE = 'special-use-vehicle',
}
